var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientNameTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 10,
    viewBox: "0 0 40 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Vector_01",
    width: 40,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAKCAYAAADGmhxQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGVSURBVHgBzZQxUsJQEIZ336jMWHEEb6BHgA5jA2VIASkU6HIDwgkYKwMWCQVgBzaRDm6g3gBvgJUTGd76FngM2pCAzrhNXv75d+abf98+hD3Kr+bOUoR+hGTb3miq9X7F8EnISfFu1NFa99q4QEHNn964JSBhreDEGAGn6jvg/w0c0DtIdHu1XGkLbkCAr9yjvX8GqOGIoGO2Qpsk2Jwkw0mCt2LryUGkLEM+VC6bSziJBasVOoTQ2QcyNuAGDqFhtUOXNes+fAHCmUouAzQfsmaqMS7UOCWgo1KeLD3s9UJXCrpNColxTN/gvDDQuk5OCBmQGjfJuQ1wDJycStJWWhMJhmY7bOiebjVXRhL1CGU2zp3cmeAuOE6TU0OUBRTHPgrweaxKm0TRSVb15fs3Rl33Wd4oIJSNuEmKpHC+k0n3KsazhtNeuRDp1YnSeCTP+WQHw9mhkCIpXOrjlJfkcRuuV7sqcXLLFNdLojf5UEj8DTiQ0mUwc32n+qqfCMcgyNVvol/Op1Opz3HSO4lqXAT/uL4AoTQ4Z1ShFycAAAAASUVORK5CYII="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientNameTop);
export default __webpack_public_path__ + "static/media/client-name-top.05f5b63c9f5b6e1ccd3a03072230fa36.svg";
export { ForwardRef as ReactComponent };